import { useQuery, type UseQueryResult } from '@tanstack/react-query';

export type TransactionDataType = {
    amount: number;
    description: string;
    isPending: boolean;
    transactionDate: string;
    location: string;
    id: string;
    declineReason?: string;
    runningBalance: number;
}

type TransactionHistoryQuery = {
    transactionHistoryQuery: UseQueryResult<TransactionDataType[]>;
    isTransactionHistoryQueryRetrieve: boolean;
};

interface TransactionHistoryQueryParams {
    startDay: string;
    endDay: string;
}

const useTransactionHistoryQuery = ({ startDay, endDay }: TransactionHistoryQueryParams): TransactionHistoryQuery => {
    const transactionHistoryQuery = useQuery({
        queryKey: ['transactionHistoryQuery', startDay, endDay],
        queryFn: async() => {
            try {
                const response = await fetch(`/api/Indue/accounts/current/transactions?startDay=${startDay}&endDay=${endDay}`);
                if (!response.ok) {
                    return Promise.reject(new Error('Failed to fetch transaction history data'));
                }

                const data = await response.json();
                return data;
            } catch (error) {
                throw new Error(`Transaction history query failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
            }
        },
        staleTime: Infinity,
    });

    const isTransactionHistoryQueryRetrieve = transactionHistoryQuery.data ?? false;

    return { transactionHistoryQuery, isTransactionHistoryQueryRetrieve };
};

export default useTransactionHistoryQuery;
